<template>
  <HistoryChangeTable
    endpoint="v2/coupon-histories"
    :base-params="{ couponProgramId }"
    :extra-params="extraParams"
    :action-options="actionOptions"
    :no-change-text="messages.NO_CHANGE"
    :no-match-text="messages.NO_MATCH"
    :invalid-date-range-text="messages.INVALID_DATE_RANGE"
    :on-error="showHistoryError"
    @show-detail="showDetail"
  >
    <template #filters-before-action="{ loading, filter }">
      <b-col cols="12" sm="6" md="3" lg="2" class="mb-2">
        <b-form-input
          size="sm"
          v-model="code"
          placeholder="Mã coupon"
          :disabled="loading"
          @keyup.enter="filter"
        />
      </b-col>
    </template>
    <template #filters-after-action="{ loading }">
      <b-col cols="12" sm="6" md="3" lg="2" class="mb-2">
        <Autosuggest
          :model="userText"
          :suggestions="userOptions"
          placeholder="Người thực hiện"
          :limit="20"
          suggestionName="name"
          :disabled="loading"
          @select="onSelectUser"
          @change="onSearchUser"
        />
      </b-col>
    </template>
    <CouponProgramHistoryDetail ref="history-detail" />
  </HistoryChangeTable>
</template>

<script>
import { debounce } from 'lodash';
import ApiService from '@/core/services/api.service';
import Autosuggest from '@/view/base/auto-sugguest/AutoSuggest.vue';
import CouponProgramHistoryDetail from '@/view/components/coupon/CouponProgramHistoryDetail.vue';
import HistoryChangeTable from '@/view/components/history/HistoryChangeTable.vue';
import {
  COUPON_HISTORY_ACTION_OPTIONS,
  COUPON_HISTORY_MESSAGES,
} from '@/utils/constants';
import { showHistoryError } from '@/view/components/coupon/coupon-history-helpers';

const SEARCH_DEBOUNCE_MS = 300;

export default {
  name: 'CouponChangeHistoryTable',
  components: { Autosuggest, CouponProgramHistoryDetail, HistoryChangeTable },
  props: {
    couponProgramId: { type: [Number, String], required: true },
  },
  data() {
    return {
      actionOptions: COUPON_HISTORY_ACTION_OPTIONS,
      messages: COUPON_HISTORY_MESSAGES,
      code: '',
      updatedBy: null,
      userText: '',
      userOptions: [],
    };
  },
  computed: {
    extraParams() {
      return { code: this.code.trim() || null, updatedBy: this.updatedBy };
    },
  },
  created() {
    this.debounceSearchUser = debounce(this.fetchUsers, SEARCH_DEBOUNCE_MS);
  },
  methods: {
    showHistoryError,
    onSearchUser(text) {
      this.userText = text;
      if (!text) this.updatedBy = null;
      this.debounceSearchUser(text);
    },
    onSelectUser(option) {
      this.updatedBy = option ? option.item.id : null;
    },
    async fetchUsers(search) {
      try {
        const { data } = await ApiService.query('v2/coupon-histories/users', {
          params: { search },
        });
        this.userOptions = data.data;
      } catch (error) {
        this.userOptions = [];
      }
    },
    showDetail(item) {
      this.$refs['history-detail'].show(item.id);
    },
  },
};
</script>
